import {
	faFileArchive,
	faFileAudio,
	faFileContract,
	faFileCsv,
	faFileImage,
	faFilePdf,
	faFilePowerpoint,
	faFileSpreadsheet,
	faFileVideo,
	faFileWord,
	IconDefinition,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FunctionComponent } from "react";

interface IProps {
	extension: string;
}

interface IIConMap {
	[key: string]: IconDefinition;
}

export const FileIcon: FunctionComponent<IProps> = props => {
	const extensionMap: IIConMap = {
		docx: faFileWord,
		doc: faFileWord,
		pptx: faFilePowerpoint,
		ppt: faFilePowerpoint,
		pdf: faFilePdf,
		csv: faFileCsv,
		xls: faFileSpreadsheet,
		xlsx: faFileSpreadsheet,
		// Video
		mp4: faFileVideo,
		mov: faFileVideo,
		// Audio
		mp3: faFileAudio,
		ogg: faFileAudio,
		wav: faFileAudio,
		// Image
		jpg: faFileImage,
		jpeg: faFileImage,
		png: faFileImage,
		svg: faFileImage,

		zip: faFileArchive,
	};

	return (
		<FontAwesomeIcon
			icon={
				extensionMap[props.extension.toLowerCase()]
					? extensionMap[props.extension.toLocaleLowerCase()]
					: faFileContract
			}
			size="lg"
			fixedWidth
		/>
	);
};
